module.exports = {
  BLOG_POSTS_PER_PAGE: 20,
  PORTFOLIO_ITEMS_PER_PAGE: 50,
};
